import React from 'react';
import classNames from 'classnames';
import { ALLOCATION_SEGMENT_COLORS, MY_TEAM_LABELS } from 'constants/myTeam';

import type { TeamAllocationItem } from '../types';

interface AllocationProgressBarProps {
  allocations?: TeamAllocationItem[];
  hoveredIndex?: number | null;
  onHoverIndex?: (index: number | null) => void;
}

const AllocationProgressBar = ({ allocations = [], hoveredIndex = null, onHoverIndex }: AllocationProgressBarProps) => {
  const normalizedAllocations = allocations
    .map((item, index) => ({ item, index }))
    .filter(({ item }) => Number(item?.allocation || 0) > 0);
  const totalHours = normalizedAllocations.reduce((total, { item }) => total + Number(item?.allocation || 0), 0);

  if (!normalizedAllocations.length || totalHours <= 0) {
    return <p className="my-team__table-text">{MY_TEAM_LABELS.PLACEHOLDER}</p>;
  }

  return (
    <div className="my-team__allocation-bar" onMouseLeave={() => onHoverIndex?.(null)}>
      {normalizedAllocations.map(({ item, index }, position) => {
        const isHovered = hoveredIndex === index;
        const isFirst = position === 0;
        const isLast = position === normalizedAllocations.length - 1;

        return (
          <React.Fragment key={String(item?.id || item?.name || index)}>
            <div
              onMouseEnter={() => onHoverIndex?.(index)}
              className={classNames('my-team__allocation-segment', {
                'my-team__allocation-segment--first': isFirst,
                'my-team__allocation-segment--last': isLast,
                'my-team__allocation-segment--dimmed': hoveredIndex !== null && !isHovered,
              })}
              style={{
                flexGrow: Number(item?.allocation || 0),
                background: ALLOCATION_SEGMENT_COLORS[index % ALLOCATION_SEGMENT_COLORS.length],
              }}
            />
            {!isLast ? <span className="my-team__allocation-divider" /> : null}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default AllocationProgressBar;
